<template>
  <img :src="icon | url"/>
</template>

<script>
export default {
  name: 'product-offer-icon',
  props: ['icon'],
  filters: {
    url: function (value) {
      if (value === null) {
        return 'static/img/default-product-flag.png'
      } else {
        return value.replace('##', 'small')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductOfferIcon.vue